// extracted by mini-css-extract-plugin
module.exports = {"container":"PreDelivering_container__3OsKi"};